import { defineComponent as _defineComponent } from 'vue'
import {DebitType, SepaType, TransactionType} from "@/Enums";
import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";
import ConfirmationDialog from "@/components/base/ConfirmationDialog.vue";
import {PropType, ref, watch} from "vue";
import type {SepaExport} from "@/components/bankTransfers/scripts";
import {Pagination} from "@/scripts/Common/paginationType";
import {useI18n} from "@/composables/useI18n";
import {getSepaAccountingPeriod} from "@/components/bankTransfers/scripts";
import {XML_ENDING} from "@/scripts/Common/Constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'BankTransferList',
  props: {
  hasNoEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  hasNoDownloadRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  sepaDocuments: {
    required: true,
    type: Array as PropType<SepaExport[]>
  },
  pagination: {
    required: true,
    type: Object as PropType<Pagination>
  }
},
  emits: [
  'onDownload',
  'onTryReset',
  'onPaginationAction',
],
  setup(__props, { emit: emits }) {

const props = __props;

const {
  t,
  d,
} = useI18n();





const selectedSepaExport = ref<SepaExport>();
const downloadDialog = ref();

const transactionTypeMap = {
  [TransactionType.all]: '',
  [TransactionType.terminal]: t('file_addition_terminal_transactions'),
  [TransactionType.other]: t('file_addition_other_transactions'),
  [TransactionType.charges]: t('file_addition_charge_transactions')
}

const transactionTypeString = (type: TransactionType) => {
  return transactionTypeMap[type] ?? '';
}

const debitTypeMap = {
  [DebitType.all]: '',
  [DebitType.basic]: t('debit_type_basic'),
  [DebitType.company]: t('debit_type_company')
}

const debitTypeString = (type: DebitType) => {
  return debitTypeMap[type] ?? '';
}

const getAccountingPeriod = (sepaDocument: SepaExport) => {
  return (sepaDocument.accountingStartDate === sepaDocument.accountingEndDate)
      ? d(Date.parse(sepaDocument.accountingStartDate), 'short')
      : `${d(Date.parse(sepaDocument.accountingStartDate), 'short')} - ${d(Date.parse(sepaDocument.accountingEndDate), 'short')}`;
}

const sepaTypeString = (type: SepaType) => {
  return type === SepaType.pain_001_003_03 ? t('file_addition_credit') : '';
}

const onHandleMarkAsDownloaded = (sepaDocument: SepaExport) => {
  selectedSepaExport.value = sepaDocument;
  sepaDocument.exportedAt
      ? (downloadDialog.value as any).Show()
      : onHandleDownload(sepaDocument);
}

const getSepaFilename = (sepaDocument: SepaExport) => {
  const accountingPeriod = getSepaAccountingPeriod(sepaDocument.accountingStartDate, sepaDocument.accountingEndDate);
  const debitType = debitTypeString(sepaDocument.debitType);
  const transactionType = transactionTypeString(sepaDocument.transactionType);
  const sepaType = sepaTypeString(sepaDocument.type);

  return `${accountingPeriod}_${transactionType}_${debitType}${sepaType}${XML_ENDING}`;
}

const onHandleDownload = (sepaDocument: SepaExport | undefined) => {
  if (!sepaDocument) return;

  const filename = getSepaFilename(sepaDocument);
  const sepaDocumentId = sepaDocument.id;
  emits('onDownload', {sepaDocumentId, filename});
}

const onHandleTryReset = (sepaDocumentId: number) => {
  emits('onTryReset', sepaDocumentId);
}

const onHandlePaginationAction = () => {
  emits('onPaginationAction')
}

watch(props.pagination, () => {
  onHandlePaginationAction();
});

return { __sfc: true,t, d, props, emits, selectedSepaExport, downloadDialog, transactionTypeMap, transactionTypeString, debitTypeMap, debitTypeString, getAccountingPeriod, sepaTypeString, onHandleMarkAsDownloaded, getSepaFilename, onHandleDownload, onHandleTryReset, onHandlePaginationAction, SepaType, FloatingActionButton, ConfirmationDialog }
}

})